import { render } from "./WardManagement.vue?vue&type=template&id=c97336e2&scoped=true"
import script from "./WardManagement.vue?vue&type=script&lang=js"
export * from "./WardManagement.vue?vue&type=script&lang=js"

import "./WardManagement.vue?vue&type=style&index=0&id=c97336e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97336e2"]])

export default __exports__